import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { HOMEPAGE_MENU_CONFIG } from './base/homepage-menu-config';

export const homepageMenuRoutes: Routes = [
  {
    path: HOMEPAGE_MENU_CONFIG.routePath!,
    data: { title: 'Homepage Menu' },
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/homepage-menu-list-page/homepage-menu-list-page.component'
          ).then((m) => m.HomepageMenuListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/homepage-menu-detail-page/homepage-menu-detail-page.component'
              ).then((m) => m.HomepageMenuDetailPageComponent),
            data: { title: 'Homepage Menu Detail' },
          },
        ],
      },
    ],
  },
];
